module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "headerStyle": {
        'background-color': _vm.currentIntegration.color.main
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Add new")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('top-area', {
    attrs: {
      "integration": _vm.currentIntegration
    }
  }, [_c('div', {
    staticClass: "bg-blue-pale p-2 mt-3"
  }, [_vm._v("\n                Note: This integration is only available for OTAs that adopt the OCTO standard. \n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 pb-4"
  }, [_c('div', {
    staticClass: "octo-integrate__otas row py-3"
  }, [_c('div', {
    staticClass: "col-12 py-5"
  }, [_c('div', {
    staticClass: "d-flex align-items-center w-100"
  }, [_c('div', {
    staticClass: "octo-integrate__step-number d-flex border-dark align-items-center justify-content-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "octo-integrate__step-text flex-grow-1"
  }, [_vm._v("\n                            To add a new OTA, you will need to provide the name and email of the OTA. Once submitted, the integration keys will be provided.\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn green octo-integrate__step-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openIntegration(_vm.currentIntegration)
      }
    }
  }, [_vm._v("\n                            Add New\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "octo-integrate__otas-list col-12 my-3"
  }, [(_vm.getIsLoadingSupplierIntegrations) ? _c('div', {
    staticClass: "d-flex flex-column justify-content-center align-items-center p-4 h-100"
  }, [_c('span', {
    staticClass: "bold fs-large"
  }, [_vm._v("Loading")]), _vm._v(" "), _c('loader')], 1) : _c('div', [_c('list', {
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.getOctoIntegrations,
      "actions": _vm.actions
    }
  })], 1)])]), _vm._v(" "), _c('bottom-area', {
    attrs: {
      "loadingConnectBtn": _vm.isOctoConnecting
    },
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4e1158"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/octoIntegrate.vue
// module id = 2806
// module chunks = 0